/* tslint:disable */
/* eslint-disable */
/**
 * backend/api/v1beta1/job.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface ApiPeriodicSchedule
 */
export interface ApiPeriodicSchedule {
  /**
   *
   * @type {Date}
   * @memberof ApiPeriodicSchedule
   */
  start_time?: Date;
  /**
   *
   * @type {Date}
   * @memberof ApiPeriodicSchedule
   */
  end_time?: Date;
  /**
   *
   * @type {string}
   * @memberof ApiPeriodicSchedule
   */
  interval_second?: string;
}

/**
 * Check if a given object implements the ApiPeriodicSchedule interface.
 */
export function instanceOfApiPeriodicSchedule(value: object): value is ApiPeriodicSchedule {
  return true;
}

export function ApiPeriodicScheduleFromJSON(json: any): ApiPeriodicSchedule {
  return ApiPeriodicScheduleFromJSONTyped(json, false);
}

export function ApiPeriodicScheduleFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ApiPeriodicSchedule {
  if (json == null) {
    return json;
  }
  return {
    start_time: json['start_time'] == null ? undefined : new Date(json['start_time']),
    end_time: json['end_time'] == null ? undefined : new Date(json['end_time']),
    interval_second: json['interval_second'] == null ? undefined : json['interval_second'],
  };
}

export function ApiPeriodicScheduleToJSON(json: any): ApiPeriodicSchedule {
  return ApiPeriodicScheduleToJSONTyped(json, false);
}

export function ApiPeriodicScheduleToJSONTyped(
  value?: ApiPeriodicSchedule | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    start_time:
      value['start_time'] == null ? value['start_time'] : value['start_time'].toISOString(),
    end_time: value['end_time'] == null ? value['end_time'] : value['end_time'].toISOString(),
    interval_second: value['interval_second'],
  };
}
